import { render } from "./ReliefTypeReport.vue?vue&type=template&id=8e6b2b3a&scoped=true"
import script from "./ReliefTypeReport.vue?vue&type=script&lang=js"
export * from "./ReliefTypeReport.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./ReliefTypeReport.vue?vue&type=style&index=1&id=8e6b2b3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e6b2b3a"]])

export default __exports__